import React, { Component } from "react";
import Header from "../decoration/header";
import Footer from "../footer/footer";
import borisImage from '../decoration/img/boris.jpg';
import matthewImage from '../decoration/img/matthew.jpeg';
import rexImage from '../decoration/img/rex.jpeg'
import ankeImage from '../decoration/img/anke.jpeg';
import bnmShopImage from '../decoration/img/bnmshop.jpg';
import "./aboutBorisAndMatthew.css";

class AboutBorisAndMatthew extends Component {
  render() {
    return (
      <div className="container-fluid about__container">
        <div className="row">
          <Header />
          <div id="banner">ABOUT BORIS &amp; MATTHEW</div>
          <div className="container">
            <div className="row">
              <div className="about__containerImage col-md-6 col-xs-12">
                <img
                  alt="main door of the shop"
                  src={bnmShopImage}
                />
              </div>
              <div className="about__containerText col-md-6 col-xs-12">
                <p>
                  Boris and Matthew pioneered the contemporary floral design
                  business in Hong Kong. Established in 2005, the floral shop is
                  famous among creative circles in Hong Kong, China and other
                  overseas countries. Their designs are bold and innovative,
                  utilizing the colour and shape of both flower and stem.
                  Co-founder Boris Wu is also the co-founder of Armani Fiori in
                  Hong Kong, Taiwan and Shanghai. He is currently the floral
                  consultant of The Venetian Macao Resort Hotel and Four Seasons
                  Hotel, renowned as Asia’s Las Vegas. Boris and Matthew
                  featured in a news program by TVB, and in magazines such as HK
                  Elle Décor, HK Newsweek and Home Journal and Spa, to name but
                  a few.
                </p>
                <br />
                <p>
                  Boris and Matthew’s daily operations include a website for
                  online purchasing, walk in customers, and they cater for
                  wedding banquets. Being floral consultants, Boris and Matthew
                  also attain a wide arrange of clients from both the corporate
                  and the private sectors. As appointees for projects with Hong
                  Kong’s most prestigious hotels, conventions and events, all
                  seeking high professionalism and value, for their images and
                  brands, Boris and Matthew is the perfect answer.
                </p>
                <br />
                <p>
                  Boris and Matthew understand the specific and individual needs
                  of their clients, whether they be corporate or private, and
                  therefore maintain excellent relationships with each and every
                  one. The main aim of Boris and Matthew is to provide a unique
                  service that guarantees to personalize their client’s brands
                  and events.
                </p>
                <br />
                <p>
                  It is a very reassuring feeling to know that Boris and
                  Matthew’s clientele is in the capable hands of skilled
                  specialists, who are sufficiently talented and experienced to
                  meet any floral diversity.
                </p>
              </div>
              <hr />
            </div>
            <div className="row ceo">
              <div className="col-md-6 col-xs-12 ">
                <img
                  className="ceo__image"
                  src={borisImage}
                  alt="boris profile"
                />
                <p className="about__containerText">
                  Boris started his floral career in 1992. Having developed a
                  unique style of his own by 1995, Boris then joined The Kowloon
                  Shangri-La . His persistent thirst for knowledge enables him
                  to be one of the most innovative and creative florists around
                  today. His magic touch around all things floral makes him a
                  mastermind of the floral industry, and he is greatly respected
                  by his peers.
                  <br />
                  <br />
                  Given the work experience and exposure he has gained
                  travelling around the world, Boris’ study of floral culture is
                  clearly reflected in his talent and passion for all things
                  floral.
                  <br />
                  <br />
                  In 1998, Boris co-founded Gary and Boris Flowers. Boris helped
                  the company expand by joining forces with Hong Kong's stylish
                  home décor company G.O.D., providing floral requirements for
                  each of the branches in Hong Kong. Boris’ experience and
                  unique style was recongnised by famous designer Giorgio
                  Armani, who invited him into a partnership with The Armani
                  Group. Hence, in 2002, Asia’s first Armani Fiori (HK) was
                  opened. This soon led to the opening of branches in other
                  Asian cities, such as Shanghai in 2003 and Taiwan in 2004.
                  <br />
                  <br />
                  In 2005, Boris and Mathew opened, bringing a new concept
                  floral shop with a café, introducing a different lifestyle and
                  business concept to the Hong Kong scene. This trend was soon
                  adopted by many business vendors in the Asia Pacific region.
                  By 2007 Boris had achieved special recognition by being
                  appointed as the official consultant for The Venetian Macao
                  Resort Hotel and Four Seasons Hotel, renowned as Asia’s Las
                  Vegas.
                  <br />
                  <br />
                  Boris’ floral arrangements adorn some of Hong Kong’s best
                  hotels, such as The Peninsula and the Four Seasons Hotel.
                  Boris also works closely with Hong Kong Government house, the
                  Hong Kong Jockey Club and David Tang’s renowned China Club. He
                  produces floral designs for major events and promotions on
                  behalf of his world class designer clients, such as such
                  Bentley Hong Kong, Cartier, Christian Dior, Franck Muller,
                  Giorgio Armani, La Mer, Polo Ralph Lauren and Valentino. His
                  client list also includes The Hong Kong Land-The Landmark,
                  Prince’s Building, Alexander House and Hong Kong Disneyland
                  Resort.
                  <br />
                  <br />
                  Boris was recently given the opportunity to teach floral
                  arrangement at the British and American Floral Art School in
                  Hong Kong.
                </p>
              </div>
              <div className="col-md-6 col-xs-12">
                <img
                  className="ceo__image"
                  src={matthewImage}
                  alt="matthew profile"
                />
                <p className="about__containerText">
                  Matthew, a bright, considerate, energetic, and efficient young
                  designer, started his career in floristry in 1998, as an
                  assistant to Boris Wu in the Gary and Boris Flowers.
                  <br />
                  <br />
                  In 2005, being a creative and imaginative floral designer,
                  Matthew went on to co-found with Boris Wu, Boris and Matthew,
                  a new concept floral shop which, with its café, brought a new
                  lifestyle and business concept to the Hong Kong business
                  scene.
                  <br />
                  <br />
                  As the Creative Director of Boris and Matthew, Matthew’s
                  minimalist and elegant style of design is well acclaimed by
                  his clients. A highly capable manager in the work place,
                  Matthew gives outstanding service to his clients, for which he
                  has gained a deservedly excellent reputation.
                  <br />
                  <br />
                  Matthew has become the key person in projects of Credit Suisse
                  Private Banking, Goldman Sachs, Hair Corner, Hang Seng Bank,
                  La Mer, On Pedder, Bank J. Safra Sarasin Ltd, Hong Kong Branch
                  , The Jockey Club, Vacheron Constantin and many other
                  important projects acquired by Boris and Matthew. It was
                  Matthew’s accomplished decoration, using 20,000 butterfly
                  orchids in the open area of Chao Yang Park in Beijing, that
                  helped to make an extravagant wedding banquet a marvellous
                  success. His design added an elegant and romantic atmosphere
                  to the venue on this splendid occasion.
                  <br />
                </p>
              </div>
            </div>
            <div className="row employees">
              <div className="col-md-2 col-xs-0"></div>
              <div className="col-md-3 col-xs-6">
                <div className="employees__box">
                  <img
                    className="employees__image"
										alt="employee rex profile"
                    src={rexImage}
                  />
                  <div className="employees__text">
                    <p className="employees__text--name">Rex</p>
                    <p className="employees__text--position">
                      Floral Design Manager
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-0"></div>
              <div className="col-md-3 col-xs-6">
                <div className="employees__box">
                  <img
                    className="employees__image"
										alt="employee anke profile"
                    src={ankeImage}
                  />
                  <div className="employees__text">
                    <p className="employees__text--name">anke</p>
                    <p className="employees__text--position">
                      Senior Floris
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    );
  }
}

export default AboutBorisAndMatthew;



// WEBPACK FOOTER //
// ./src/components/aboutBorisAndMatthew/aboutBorisAndMatthew.js